import React, { useState } from 'react';
import { ReactComponent as UpButton } from '../../../assets/upButton.svg';
import { ReactComponent as DownButton } from '../../../assets/downButton.svg';
import { useIsMobile } from '../../../hooks/useIsMobile';

interface BookIndexProps {
    index?: string;
}

const BookIndex: React.FC<BookIndexProps> = ({ index }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const isMobile = useIsMobile();

    if (!index) return null;

    return (
        <div className="flex flex-col gap-3">
            <p className={`font-bold text-black ${isMobile ? 'text-[24px]' : 'text-[40px]'}`}>
                목차
            </p>
            <div
                className={` overflow-hidden transition-all duration-300
                    ${isExpanded ? '' : isMobile ? 'max-h-[150px]' : 'max-h-[160px]'}
                    ${isMobile ? 'bg-[#f8f9fa] border border-[#e9ecef] rounded-[16px]' : ''}
                  `}
            >
                <div
                    className={`whitespace-pre-line font-namsan text-[#333] ${
                        isMobile ? 'p-5 text-[15px] leading-[22.5px]' : 'py-2 px-0 text-[18px] leading-[1.8]'
                    }`}
                >
                    {index}
                </div>
            </div>
            <div className="flex justify-end">
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className={`flex flex-row items-center gap-1.5 text-[#565659] font-namsan ${
                        isMobile ? 'text-[16px]' : 'text-[18px]'
                    }`}
                >
                    {isExpanded ? (
                        <><UpButton /><span>접기</span></>
                    ) : (
                        <><DownButton /><span>더보기</span></>
                    )}
                </button>
            </div>
        </div>
    );
};

export default BookIndex;
